import React from 'react';
import { GenericCardProps, SearchResultsContainerProps, SearchFacet } from './../../../types/search';
import ResponsiveImage from './../../utils/ResponsiveImage';

const ImageCard = ({
  data,
  viewLabel,
  categoryLabel,
}: {
  data: GenericCardProps;
  videoLabel: string;
  viewLabel: string;
  categoryLabel?: string;
}) => {
  return (
    <>
      <a className="search-card" href={data.relativePath}>
        {data.imageInfo && (
          <div className="search-card-image-wrapper">
            <ResponsiveImage
              image={{
                altText: data.imageInfo.altText || data.heading,
                src: data.imageInfo.src,
                sizes: data.imageInfo.sizes,
                srcSets: data.imageInfo.srcSets,
              }}
              width={300}
              height={200}
              className="search-card-image"
            />
          </div>
        )}
        <div className="search-card-content">
          <div className="search-card-top">
            <span className="search-card-category">{categoryLabel ?? data.primaryCategory?.id}</span>
            {data.publishingDate && (
              <div className="search-card-date">
                <span>{data.publishingDate}</span>
              </div>
            )}
          </div>
          <div className="search-card-middle">
            <h3 className="search-card-title">{data.heading}</h3>
          </div>
          <div className="search-card-icon-wrapper">
            <span className="sr-only">{viewLabel}</span>
            <svg className="search-card-icon">
              <use href="/dist/assets/icons/sprite.svg#arrow-right"></use>
            </svg>
          </div>
        </div>
      </a>
    </>
  );
};

type ContentListingSearchResultsContainerProps = SearchResultsContainerProps & {
  facets?: SearchFacet[];
};

const getCategoryLabel = (categoryId?: string | number, facets?: SearchFacet[]): string | undefined => {
  if (!categoryId || !facets) return undefined;
  const categoryFacet = facets.find(f => f.key.toLowerCase().includes('category'));
  if (!categoryFacet) return undefined;
  const item = categoryFacet.items.find(i => i.value === String(categoryId));
  return item?.label;
};

const ContentListingSearchResultsContainer = ({
  results,
  videoLabel = 'Video',
  viewLabel = 'View',
  facets,
}: ContentListingSearchResultsContainerProps) => {
  return (
    <div className="search-content__cards">
      {results.map(result => {
        function hasPrimaryCategoryNumber(obj: unknown): obj is { primaryCategory: number } {
          return (
            typeof obj === 'object' &&
            obj !== null &&
            'primaryCategory' in obj &&
            typeof (obj as { primaryCategory: unknown }).primaryCategory === 'number'
          );
        }
        const categoryId = hasPrimaryCategoryNumber(result) ? result.primaryCategory : undefined;
        return (
          <ImageCard
            key={result.id + JSON.stringify(result)}
            data={result as GenericCardProps}
            videoLabel={videoLabel}
            viewLabel={viewLabel}
            categoryLabel={categoryId ? getCategoryLabel(categoryId, facets) : undefined}
          />
        );
      })}
    </div>
  );
};

export default ContentListingSearchResultsContainer;
